import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"

const useStyles = makeStyles(() => ({
	searchFieldLabel: {
		fontSize: "14.5px",
		fontWeight: 600,
		color: colors.gray[900],
		marginBottom: 4
	}
}))

export default useStyles
